import { ArticleOrAdData, ArticleSet, TravelPersonalizedMarketingArticlesProps } from "../types/PersonalizedMarketingArticles";

export const isAd = (article: ArticleOrAdData): boolean => (
  ('placementId' in article && 'placementType' in article) 
  || ('placementName' in article && 'channelName' in article)
);

const isValidArticleOrAd = (article: ArticleOrAdData): boolean => {
  if (!article || !article?.id) return false;

  if (
    'title' in article
    && 'body' in article
    && ('imageUrl' in article || "fallbackImageUrl" in article)
    && 'ctaDestination' in article
  ) {
    if (
      !article.title
      || !article.body
      || (!article.imageUrl && !article.fallbackImageUrl)
      || !article.ctaDestination
    ) {
      return false;
    }

    return true;
  }

  if (
    'icon' in article 
    && article.id === "exploreMore"
    && 'body' in article
    && 'ctaDestination' in article
    && 'ctaLabel' in article
  ) {
    if (!article.body || !article.ctaDestination || !article.ctaLabel) {
      return false;
    }

    return true;
  }

  if ("placementId" in article || ('placementName' in article && 'channelName' in article)) {
    if (!article.placementId && (!article.placementName || !article.channelName)) {
      return false;
    }

    return true;
  }

  return false;
}

export const filterArticles = (articles: TravelPersonalizedMarketingArticlesProps['articles']): ArticleSet => {
  if (!Array.isArray(articles) || !articles || articles.length === 0) return [];

  if ('name' in articles[0] && 'articles' in articles[0]) {
    const filters = articles as { name: string; articles: ArticleOrAdData[] }[];
    return filters.map((filter) => {
      if (filter?.name && filter?.articles) {
        return ({
          name: filter.name,
          articles: filter.articles.filter(isValidArticleOrAd)
        })
      };
      return null;
    }).filter((filter) => filter !== null) as { name: string; articles: ArticleOrAdData[] }[];
  }

  return [{
    name: "default",
    articles: (articles as ArticleOrAdData[]).filter((article) => isValidArticleOrAd(article)),
  }]
}

type TagSet = {
  index: number;
  categoryName: string;
}[]

export const getTags = (articles: ArticleSet): TagSet => {
  return articles.map((article, index) => ({
    index,
    categoryName: article.name,
  }))
}

export const getActiveArticles = (
  articles: ArticleSet,
  activeTag: number
): ArticleOrAdData[] => articles[activeTag].articles;
